/**
 * Shared globals singleton for motivUi configuration.
 *
 * Consumers set window.motivUi.globals BEFORE this script loads:
 *
 *   <script>
 *     window.motivUi = {
 *       globals: { sessionGuid: '...', intl: { locale: 'en-GB' } }
 *     };
 *   </script>
 *   <script src="motivUi.js"></script>
 *
 * This module reads those values at initialization and exports the same
 * object reference used throughout motivUi. Post-load mutations to
 * motivUi.globals will be visible to all modules sharing this reference.
 */
const existingSettings = (typeof window !== 'undefined') ? window.motivUi : undefined;
const globals = (existingSettings && existingSettings.globals) || {};
globals.intl = globals.intl || {};
globals.intl.locale = globals.intl.locale || 'en-GB';
globals.intl.groupSeparator = globals.intl.groupSeparator || ',';
globals.intl.decimalSeparator = globals.intl.decimalSeparator || '.';
globals.routing = globals.routing || {};
globals.routing.pathBase = globals.routing.pathBase || '';

export default globals;
